import getVisitorId from 'mex_components/app/scripts/storage/getVisitorId';
import getClientId from 'mex_components/app/scripts/storage/getClientId';


const tabSelectionTrack = (data) => {
  var label = document.querySelector('label[for=' + data.id + ']');
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'buybox_radioButton',
    label_text: label.innerText,
    visitor_id: getVisitorId(),
    client_id: getClientId()
  });
};


export default function(el){
  el.addEventListener('click', () => tabSelectionTrack(el));
}
